import { render, staticRenderFns } from "./PositionGrid.vue?vue&type=template&id=8f3bf2f2"
import script from "./PositionGrid.vue?vue&type=script&lang=js"
export * from "./PositionGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports